
import { AssetProdConfigFormDataReducer } from "./assetProductivityReducer/AssetProductivityConfigurationReducer";
import { omniAuthLoginReducer, omniRefreshTokenReducer } from "./OmniComm/OmniCommAuthReducer";
import { SiteProductivityBarWidgetReducer, SiteProductivityLineWidgetReducer, SiteProductivityPieWidgetReducer, SiteProductivityTargetWidgetReducer } from "./SiteProductivityReducers/SiteProductivityWidgetReducer";

export const allReducer = {
    AssetProdConfigFormDataReducer,
    SiteProductivityBarWidgetReducer,
    SiteProductivityLineWidgetReducer, 
    SiteProductivityPieWidgetReducer, 
    SiteProductivityTargetWidgetReducer,
    omniAuthLoginReducer,
    omniRefreshTokenReducer
}